import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex max-w-full items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-micro font-medium',
  {
    variants: {
      tone: {
        neutral: 'bg-surface-3 text-fg-muted',
        good: 'bg-good-tint text-good-fg',
        warn: 'bg-warn-tint text-warn-fg',
        bad: 'bg-bad-tint text-bad-fg',
        brand: 'bg-brand-tint text-brand',
        lead: 'bg-accent-lead/15 text-accent-lead',
        booking: 'bg-accent-booking/15 text-accent-booking',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
